module.exports = __webpack_public_path__ + "static/media/empty_catalog.8373089a.png";